import { FC } from 'react';
import { FieldRenderProps } from 'react-final-form';

type TableFilterTextFieldProps = FieldRenderProps<
  string,
  HTMLElement,
  string
> & {
  labelText?: string;
};

const TableFilterTextField: FC<TableFilterTextFieldProps> = ({
  input,
  labelText,
  ...otherProps
}) => {
  return (
    <div className="relative w-full">
      <label
        className="absolute -top-2 left-2 inline-block bg-white px-1 text-xs font-medium text-gray-500"
        htmlFor={input.name}
      >
        {labelText || input.name}
      </label>
      <input
        id={input.name}
        type="text"
        className="block w-full rounded-md border-gray-300 text-sm shadow-sm"
        autoComplete="off"
        {...input}
        {...otherProps}
      />
    </div>
  );
};

export default TableFilterTextField;
